var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import log from '../whisper';
export default function fetchAndSetCif(session, onComplete, onFailure) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var customerinfo, headers, customerinfo, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!session.cif) return [3 /*break*/, 1];
                    customerinfo = session.cif;
                    log.info({
                        message: "Setting cookie: bvid=".concat(customerinfo, ";domain=.ally.com;"),
                    });
                    document.cookie = "bvid=".concat(customerinfo, ";domain=.ally.com;");
                    log.info({ message: 'Navigating to storefront...' });
                    onComplete();
                    return [3 /*break*/, 4];
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    headers = {
                        Accept: 'application/v1+json',
                        Authorization: "Bearer ".concat((_a = session.AwsAccessToken) !== null && _a !== void 0 ? _a : ''),
                        ApplicationId: 'ALLYUSBOLB',
                        ApplicationName: 'AOB',
                        ApplicationVersion: '1.0',
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'patron-id': 'olbWeb',
                        spname: 'auth',
                        CSRFChallengeToken: (_b = session.CSRFChallengeToken) !== null && _b !== void 0 ? _b : '',
                        'X-Requested-With': 'XMLHttpRequest',
                    };
                    log.info({ message: 'Storefront redirect detected. Fetching CIF...' });
                    return [4 /*yield*/, fetch('/capi-gw/customerinfo/primary/olbWeb', {
                            headers: headers,
                        }).then(function (response) { return response.json(); })];
                case 2:
                    customerinfo = _c.sent();
                    log.info({
                        message: "Setting cookie: bvid=".concat(customerinfo, ";domain=.ally.com;"),
                    });
                    document.cookie = "bvid=".concat(customerinfo, ";domain=.ally.com;");
                    log.info({ message: 'Navigating to storefront...' });
                    onComplete();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    log.error({
                        message: "Failure fetching cif and redirecting: ".concat(e_1.message),
                    });
                    onFailure();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=fetchAndSetCif.js.map